import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE, ROUTE_PATH } from "../../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
} from "../../../components/RegularComponents";
import CheckboxForm from "../../../components/CheckBoxForm";
import TopNavigationBar from "../../TopNavigationBar";
import { setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { ERROR_STRING } from "../../../app/errors";
import { fullName } from "../../../app/utils";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";

const MORTGAGE_APPLICATION_PROPERTY = "principalBrokerDutiesConfirmation";

export const AgentDutiesConfirmation = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  
  const [confirmCheck1, setConfirmCheck1] = useState(false);
  const [confirmCheck2, setConfirmCheck2] = useState(false);
  const [confirmCheck3, setConfirmCheck3] = useState(false);
  const [confirmCheck4, setConfirmCheck4] = useState(false);
  const [confirmCheck5, setConfirmCheck5] = useState(false);
  const [confirmCheck6, setConfirmCheck6] = useState(false);
  const [confirmCheck7, setConfirmCheck7] = useState(false);
  const [confirmCheck8, setConfirmCheck8] = useState(false);
  const [confirmCheck9, setConfirmCheck9] = useState(false);

  const [showValidationError, setShowValidationError] = useState(false);

  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  let mainAgentPersonData = agencyApplication.businessLicenceData?.personData;
  
  const handleNext = () => {
    if(isPrincipalBroker) {
      if (
        !confirmCheck1 ||
        !confirmCheck2 ||
        !confirmCheck3 ||
        !confirmCheck4 ||
        !confirmCheck5 ||
        !confirmCheck6 ||
        !confirmCheck7 ||
        !confirmCheck8 ||
        !confirmCheck9
      ) {
        setShowValidationError(true);
        return;
      }
    } else {
      if (
        !confirmCheck1 ||
        !confirmCheck2
      ) {
        setShowValidationError(true);
        return;
      }
    }
    
    setShowValidationError(false);

    // Set MORTGAGE PROP value
    dispatch(
      setMortgageProperty({
        key: "principalBrokerDutiesConfirmation",
        value: true,
      })
    );

    // On to the next item
    dispatch(
      push(
        `/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CURRENT_NS_LICENCE_NUMBER}`
        // `/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONFIRM_CURRENT_NS_LICENCE_NUMBER}`
      )
    );
  };

  const handleModalClose = () => {
    // Set MORTGAGE PROP value
    dispatch(
      setMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value:
          confirmCheck1 &&
          confirmCheck2 &&
          confirmCheck3 &&
          confirmCheck4 &&
          confirmCheck5 &&
          confirmCheck6 &&
          confirmCheck7 &&
          confirmCheck8 &&
          confirmCheck9,
      })
    );

    onEditSave();
  };

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar 
              {...props} 
              applicationType={APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE} 
              applicationMode={APPLICATION_MODE_NEW} 
            />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "20px" }}
                  id="broker-confirmation-header"
                  header="Confirmation"
                />
                <Paragraph
                  style={{ paddingBottom: "20px" }}
                  id="broker-confirmation-header"
                  text={[
                    `I, ${fullName(mainAgentPersonData)}, confirm that I have read and understand the Mortgage Regulation Act and its regulations and agree to be bound by their provisions.`,
                    `I, ${fullName(mainAgentPersonData)}, confirm as ${isPrincipalBroker ? 'Principal Broker' : 'Compliance Officer'} I am able to carry out the duties and responsibilities of a ${isPrincipalBroker ? 'principal broker' : 'compliance officer'} on behalf of the mortgage brokerage.  Some of those duties include:`,
                  ]}
                />
              </div>
            </div>
          </>
        )}
        
        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-1"
              checked={confirmCheck1}
              value={confirmCheck1}
              labelStyle={{ fontWeight: "normal !important" }}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck1(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                "Acting as a liaison or contact person with the Registrar for all matters concerning the operation of the mortgage brokerage, including licensing matters, complaints, inspections, responding to directions, orders, demands, or requirements of the Registrar and annual returns provided to the Registrar under Section 54 of the Act.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-2"
              checked={confirmCheck2}
              value={confirmCheck2}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck2(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                "Establishing, maintaining and periodically reviewing policies and procedures for the mortgage brokerage to assist the brokerage and each of its authorized mortgage brokers and authorized associate mortgage brokers in complying with the Act and its regulations.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-3"
              checked={confirmCheck3}
              value={confirmCheck3}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck3(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                "Ensuring that each authorized mortgage broker and authorized associate mortgage broker is competent to carry out their duties and responsibilities under the Act and its regulations.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-4"
              checked={confirmCheck4}
              value={confirmCheck4}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck4(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                "Ensuring that each authorized associate mortgage broker is adequately supervised.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-5"
              checked={confirmCheck5}
              value={confirmCheck5}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck5(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                "Ensuring that regular audits are carried out on the work of the mortgage brokerage and of each authorized mortgage broker and authorized associate mortgage broker, and investigate and respond to any complaints made to the brokerage.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-6"
              checked={confirmCheck6}
              value={confirmCheck6}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck6(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                "Advising the Registrar immediately on becoming aware of any contravention of the Act or its regulations by the mortgage brokerage or an authorized mortgage broker or authorized associate mortgage broker.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-7"
              checked={confirmCheck7}
              value={confirmCheck7}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck7(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                "Advising the Registrar in writing immediately if any mortgage broker or associate mortgage broker ceases to be authorized to broker mortgages on behalf of the mortgage brokerage.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-8"
              checked={confirmCheck8}
              value={confirmCheck8}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck8(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                "Ensuring that the mortgage brokerage immediately notifies the Registrar in writing of any change to a business address or electronic address provided in an application for a licence or licence renewal, as required by Section 21 of the Act.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-9"
              checked={confirmCheck9}
              value={confirmCheck9}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck9(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                "Ensuring that the mortgage brokerage notifies the Registrar in writing of any change of circumstances as required by Section 22 of the Act in accordance with, and within the time period prescribed by, the Reporting Requirements Regulations made under the Act.",
              ]}
            />
          </div>
        </div>

        <div className="row topMarginNormal">
          <div
            className={"col-lg-4" + (showValidationError ? " has-error" : "")}
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleNext : handleModalClose}
            />
            {showValidationError && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
